export const ENV_NAME = 'development'
export const HOST_NAME = 'localhost'
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/ops-api'
export const SENTRY_DSN = null

export const FIREBASE = {
  apiKey: 'AIzaSyDk1KFkOAghGk9T3GF3YI0hhPR0Mz4LmY4',
  authDomain: 'mymove-staging.firebaseapp.com',
  projectId: 'mymove-staging',
  appId: '1:7972322512:web:4aedf82411c736f15eb2d5',
}
